export default {"src":"/_next/static/media/poly.32aae0a2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};